import React from 'react';
export default function MeetingTime() {
    return (
        // <Card className='xsmallitem' raised>
        //     <CardContent className=''>
        <React.Fragment>
            <h1>Lunch Meetings</h1>
            <div className='body2'>1st & 3rd Tuesdays<br />
            KC Hall (475 Franklin Ave)<br />
            12:15 PM - 1:30 PM</div>

            <h1>Happy Hour Meetings</h1>
            <div className='body2'>2nd & 4th Tuesdays<br />
            Café Hope (Timberlane Country Club)<br />
            5:30 PM - 7:00 PM</div>
            <h1>General Information:</h1>
            <div className='body2'>Interested in getting involved in the Rotary Club of the Westbank?</div>
            <h1>Mailing Address:</h1>
            <div className='body2'>P.O. Box 3407 Gretna, LA 70054</div>
        </React.Fragment>
        // </CardContent>
        // </Card>
    );
};